import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidoAnalyze: {},
  sidoAnalyzeInit: false,
  sidoAnalyzeRealPriceCount: {},
  sidoAnalyzeRealPriceCountInit: false,
  gunguPriceIndex: {},
  gunguPriceIndexInitialize: false,
};

const reducers = {
  getSidoAnalyze(state, action) {
    const payload = action.payload;
    state.sidoAnalyze = payload;
    state.sidoAnalyzeInit = true;
  },
  getSidoAnalyzeRealPriceCount(state, action) {
    const payload = action.payload;
    state.sidoAnalyzeRealPriceCount = payload;
    state.sidoAnalyzeRealPriceCountInit = true;
  },
};

export const slice = createSlice({
  name: "analyze",
  initialState,
  reducers,
});

export const { reducer } = slice;
